import { render, staticRenderFns } from "./CreateTableModal.vue?vue&type=template&id=f52127ba&"
import script from "./CreateTableModal.vue?vue&type=script&lang=ts&"
export * from "./CreateTableModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports